import React from 'react'
import { useLocation } from 'react-router-dom'
const scrollToAnchor = (hash, scrollOptions = {}) => {
  setTimeout(() => {
    const id = hash.replace('#', '').trim()
    const element = document.getElementById(id)
    if (element) element.scrollIntoView(scrollOptions)
  }, 0)
}

function WindowScroll({
  options,
  children,
  transform = (hash, options) => hash,
}) {
  const location = window.location
  React.useEffect(() => {
    if (location.hash)
      scrollToAnchor(transform(location.hash, options), options)
  }, [location.hash, options])

  return children ?? null
}

function RouterScroll({
  options,
  children,
  transform = (hash, options) => hash,
}) {
  const location = useLocation()
  React.useEffect(() => {
    if (location.hash)
      scrollToAnchor(transform(location.hash, options), options)
  }, [location.hash, options])

  return children ?? null
}

const ScrollToViewByHash = ({
  options,
  children,
  useWindow = false,
  transform = (hash, options) => hash,
}) =>
  useWindow ? (
    <WindowScroll
      options={options}
      transform={transform}>
      {children}
    </WindowScroll>
  ) : (
    <RouterScroll
      options={options}
      transform={transform}>
      {children}
    </RouterScroll>
  )

export default ScrollToViewByHash
